'use strict';

class OfferList {
  constructor($location, offerService, originatorService) {
    this.$location = $location;
    this.offerService = offerService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.alert = {};

    this.statistics = {};
    this.open = [];
    this.accepted = [];
    this.cancelled = [];
    this.drafts = [];

    this.tables = {
      open: true,
      accepted: false,
      cancelled: false,
      drafts: false
    };

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });

    this.loadDashboardData();
    this.loadOpen();
    this.loadDrafts();
  }

  loadGraph() {
    this.showGraph = true;

    this.chartData = {
      labels: this.statistics.labels,
      datasets: [{
        fillColor: 'rgba(205,92,92,0.5)',
        strokeColor: 'rgba(205,92,92,1)',
        pointColor: 'rgba(205,92,92,1)',
        pointStrokeColor: '#eee',
        data: this.statistics.cancelled
      }, {
        fillColor: 'rgba(46,139,87, 0.7)',
        strokeColor: 'rgba(46,139,87,1)',
        pointColor: 'rgba(46,139,87,1)',
        pointStrokeColor: '#ddd',
        data: this.statistics.accepted
      }]
    };

    // hide if no data to show
    if (this.statistics.count.accepted === 0) {
      if (this.statistics.count.cancelled === 0) {
        this.showGraph = false;
      }
    }
  }

  loadDashboardData() {
    this.offerService.getStatistics()
      .then((resp) => {
        this.statistics = resp.data;
        this.loadGraph();
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke hente statistikk'
        };
      });
  }

  loadOpen() {
    this.offerService.getOpen()
      .then((resp) => {
        this.open = resp.data;

        this.tables.open = true;
        this.tables.accepted = false;
        this.tables.cancelled = false;
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke laste &aring;pne tilbud'
        };
      });
  }

  loadAccepted() {
    this.offerService.getAccepted()
      .then((resp) => {
        this.accepted = resp.data;

        this.tables.open = false;
        this.tables.accepted = true;
        this.tables.cancelled = false;
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke laste godtatte tilbud'
        };
      });
  }

  loadCancelled() {
    this.offerService.getCancelled()
      .then((resp) => {
        this.cancelled = resp.data;

        this.tables.open = false;
        this.tables.accepted = false;
        this.tables.cancelled = true;
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke laste avsl&aring;tte tilbud'
        };
      });
  }

  loadDrafts() {
    this.offerService.getDrafts()
      .then((resp) => {
        this.drafts = resp.data;
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke laste halvferdige tilbud'
        };
      });
  }

  cancelDocument(number) {
    this.offerService.cancelDocument(number)
      .then(() => {
        this.loadDashboardData();
        this.loadOpen();
      })
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke merke tilbud som avsl&aring;tt'
        };
      });
  }

  deleteDraft(number) {
    this.offerService.deleteDraft(number)
      .then(() => this.loadDrafts())
      .catch(() => {
        this.alert = {
          type: 'error',
          message: 'Kunne ikke slette tilbud'
        };
      });
  }
}

OfferList.$inject = ['$location', 'offerService', 'originatorService'];

const offerList = {
  controller: OfferList,
  templateUrl: 'offer/list.html'
};

angular
  .module('SendRegning')
  .component('offerList', offerList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/tilbud', {
        title: 'Tilbud - Oversikt',
        template: '<offer-list />',
        secure: true
      });
  });
